import React from "react";
import GroupLevelRanking from "../groupLevelRanking/GroupLevelRanking";
import { UnitType } from "shared/reports/models/UnityType";

interface RankingReportCellProps {
    rank: number;
    numberOfCompetitors?: number;
    change: number;
    planTarget?: number;
    planValue?: number;
    unit: UnitType;
}

const RankingReportCell: React.FC<RankingReportCellProps> = (props: RankingReportCellProps) => {
    return (
        <GroupLevelRanking
            rank={props.rank}
            change={props.change}
            planTarget={props.planTarget}
            planValue={props.planValue}
            numberOfCompetitors={props.numberOfCompetitors}
            compact
            unit={props.unit}
        />
    );
};

export default RankingReportCell;
